var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 124,
    fill: "#d5d5d3",
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 200h-16v-21.194l-30.247-37.806 12.494-10 32 40a8 8 0 0 1 1.753 5z",
    fill: "#d5d5d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 96-16 8v8a16 16 0 0 1 -16 16h-48v-80h64v24l5.33 8z",
    fill: "#fdc8a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.33 80h-37.33v-16h32v8z",
    fill: "#fdb683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 352h56v48h-56z",
    fill: "#c7483c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 432,
    fill: "#34507b",
    r: 56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 432,
    fill: "#d5d5d3",
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 136h96a16 16 0 0 1 16 16v112a0 0 0 0 1 0 0h-128a0 0 0 0 1 0 0v-112a16 16 0 0 1 16-16z",
    fill: "#d65246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 192h16v48h-16z",
    fill: "#df6257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 160h128v16h-128z",
    fill: "#c7483c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.029 408.971 49.942-49.942a24 24 0 0 0 7.029-16.97v-62.059a32 32 0 0 1 32-32v40a40 40 0 0 0 40 40v32h-17.844a32 32 0 0 0 -23.678 10.474l-60.956 67.052a32 32 0 0 1 -23.678 10.474h-289.844a105.442 105.442 0 0 1 86.58-103.742l1.42-.258v-32h136a27.672 27.672 0 0 1 -23.759 27.394 37.552 37.552 0 0 0 -32.241 37.175v1.879a37.553 37.553 0 0 0 37.552 37.552h64.507a24 24 0 0 0 16.97-7.029z",
    fill: "#d65246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.285 387.575-6.138-14.775a81.91 81.91 0 0 1 16.727-4.927l2.861 15.742a65.794 65.794 0 0 0 -13.45 3.96z",
    fill: "#df6257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.522 419.487-14.4-6.974a81.646 81.646 0 0 1 27.363-31.768l9.03 13.209a65.626 65.626 0 0 0 -21.993 25.533z",
    fill: "#df6257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 264h-128a8 8 0 0 0 -8 8v9.32a16.008 16.008 0 0 0 13.14 15.75l81.43 14.8a7.608 7.608 0 0 0 1.43.13h40a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8zm-8 32h-31.28l-80.72-14.68v-1.32h112z",
    fill: "#d5d5d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 64h-40v19a21 21 0 0 1 -32 17.89 20.611 20.611 0 0 1 -3.09-2.32 20.9 20.9 0 0 1 -6.8-13.48l-1.71-17.11a39.992 39.992 0 0 1 39.8-43.98h3.8a40 40 0 0 1 40 40z",
    fill: "#d65246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184 240v16a24 24 0 0 0 24 24h80l-40 104h40l37.6-90.517a38.658 38.658 0 0 0 -2.388-34.441 38.655 38.655 0 0 0 -33.312-19.042z",
    fill: "#7a432a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 184-48-56h-48v112h64v-40l8.971 8.971a24 24 0 0 0 16.97 7.029h78.059v-32z",
    fill: "#d65246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 248h64v-56h-14.111a28.944 28.944 0 0 0 -25.889 16l-24 8z",
    fill: "#d65246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488 432a55.967 55.967 0 1 1 -.57-8 56 56 0 0 1 .57 8z",
    fill: "#34507b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.43 424h-63.43l-31.68 47.52a56 56 0 1 1 95.11-47.52z",
    fill: "#2f486e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455 432a24.025 24.025 0 1 1 -1.38-8 23.6 23.6 0 0 1 1.38 8z",
    fill: "#cececc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.62 424h-29.62l-13.57 20.35a23.994 23.994 0 1 1 43.19-20.35z",
    fill: "#c6c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396 419.151 24.5 24.5a14.849 14.849 0 0 0 21 0 14.849 14.849 0 0 0 0-21l-24.5-24.5z",
    fill: "#d5d5d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 456h32l32-48h64a48 48 0 0 0 -48-48h-16a64 64 0 0 0 -64 64z",
    fill: "#d65246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 184v32l16 8v16h32v-40z",
    fill: "#fdc8a2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 232,
    fill: "#34507b",
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c7483c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112 336h56v16h-56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.059 432h-150.059v-16h166.059a24 24 0 0 0 16.97-7.029l.971-.971-16.971 16.971a24 24 0 0 1 -16.97 7.029z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424 352a72.1 72.1 0 0 0 -70.98 60h16.289a56.088 56.088 0 0 1 54.691-44h16v-16z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#34507b",
    height: 32,
    rx: 16,
    width: 96,
    x: 152,
    y: 280
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 201.373-26.343-26.343-11.314 11.313 37.657 37.657z",
    fill: "#c7483c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 384h48a16 16 0 0 1 16 16 16 16 0 0 1 -16 16h-48a0 0 0 0 1 0 0v-32a0 0 0 0 1 0 0z",
    fill: "#d5d5d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryBike);
export default __webpack_public_path__ + "static/media/delivery-bike.d3bfcabad0dbe273e25e6e6409d4794e.svg";
export { ForwardRef as ReactComponent };